<template>

    <div id="entry">
        <div class="common-header container clearfix" @click="goHome">
            <div class="logo"></div>
            <div title="" class="title">{{ mecoName }}机考模拟系统</div>
        </div>
        <div class="main">
            <section class="courseList">
                <div id="realMockExam">
                    <div class="stepContainer step1" v-if="idx == 0">
                        <div class="layout">
                            <h2 class="title">{{ mecoTitle }}</h2>
                            <h1 class="num">机位号：<span>{{ mecoSeat }}</span></h1>
                            <div class="lbox">
                                <p class="ltitle">考生登录</p>
                                <div class="lcnt">
                                    <div class="linp"><label>准考证号：</label>
                                        <el-input v-model="code" placeholder="请输入准考证号"></el-input>
                                    </div>
                                    <div class="linp"><label>证件号码：</label>
                                        <el-input v-model="idcard" placeholder="请输入证件号码"></el-input>
                                    </div>
                                    <div class="lbtns">
                                        <el-button type="primary" @click="login">登录</el-button>
                                        <el-button type="danger" @click="reset">重置</el-button>
                                    </div>
                                </div>
                            </div>
                            <div class="tip"> 提示：准考证号为：11111111 证件号码为：111111111111111111 </div>

                        </div>
                    </div>

                    <div class="stepContainer step2" v-if="idx == 1">
                        <div class="layout">
                            <h2 class="title">{{ mecoTitle }}</h2>
                            <h1 class="num">机位号：<span>{{ mecoSeat }}</span></h1>
                            <div class="lbox">
                                <p class="ltitle"><i class="el-icon-bell"></i> 温馨提示：请仔细核对个人信息，如有错误请报告老师！ </p>
                                <div class="lcnt clearfix">
                                    <div class="fl do"><img src="../../../public/images/touxiang.png"></div>
                                    <div class="fl dt">
                                        <p class="clearfix"><label class="fl">准考证号：</label><span>11111111</span></p>
                                        <p class="clearfix"><label class="fl">姓名：</label><span>m930742868</span></p>
                                        <p class="clearfix"><label class="fl">性别：</label><span>X</span></p>
                                        <p class="clearfix"><label class="fl">考试科目：</label><span>{{ mecoTitle }}</span>
                                        </p>
                                        <p class="clearfix"><label
                                                class="fl">证件号码：</label><span>111111111111111111</span></p>
                                        <p class="clearfix"><label class="fl">座位号：</label><span>{{ mecoSeat }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="lbtns">
                                <el-button type="primary" @click="loginBtn">确认登录</el-button>
                                <el-button type="danger" @click="resetBtn">返回</el-button>
                            </div>

                        </div>
                    </div>


                </div>
            </section>
        </div>
        <div class="footer"></div>
    </div>


</template>

<script>
import Login from '../Login.vue';

export default {
    data() {
        return {
            idx: 0,
            code: "11111111",
            idcard: "111111111111111111",
            mecoSeat: "",
            mecoName: sessionStorage.getItem("access-mecoName"),
            mecoTitle: sessionStorage.getItem("access-mecoTitle"),
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        let random = Math.floor(Math.random() * 100);
        this.mecoSeat = random;
        sessionStorage.setItem("access-mecoSeat", random);
    },
    methods: {
        goHome() {
            this.$confirm('确认要退出考试吗？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push("/web/index");
            });
        },

        login() {
            if (this.code == '') {
                alert('请填写准考证号');
                return false;
            }

            if (this.idcard == '') {
                alert('请填写证件号码');
                return false;
            }
            this.idx = 1;
        },

        loginBtn() {
            this.$router.push({
                path: "/meco/notice",
                query: {
                    paper_id: this.paper_id,
                },
            });
            //this.$router.push("/meco/notice");
        },

        resetBtn() {
            this.idx = 0;
        },


        reset() {
            this.code = "";
            this.idcard = "";
        },

        mycourse() {
            this.$router.push("/meco/login");
        },
    },
};
</script>
<style>
@import "../../../public/css/meco.css";

.el-input {
    width: 70% !important;
}

.el-button {
    width: 120px !important;
}
</style>
